/**
 * @file: 流动线速度keyframes创建
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../UIToolkit/index';

export default function createFlowBorderKeyframes(): void {
    let keyframeStyle: HTMLElement = document.querySelector('#flowborder-keyframe');

    if (keyframeStyle) {
        return;
    }
    const runkeyframes =`
        @keyframes borderRunXKeyframes {
            100% {
                transform: translate3d(${UIToolkit.flowBorderSpace() * 2}px, 0, 0);
            }
        }

        @keyframes borderRunYKeyframes {
            100% {
                transform: translate3d(0, ${UIToolkit.flowBorderSpace() * 2}px, 0);
            }
        }
    `;

    const style: any = document.createElement('style');

    style.id = 'flowborder-keyframe';
    style.type = 'text/css';
    style.innerHTML = runkeyframes;
    document.getElementsByTagName('head')[0].appendChild(style);
}
